import { createReducer, on } from '@ngrx/store';
import {
  setRolesToDelete,
  getRoles,
  sentRoles,
  saveRoles,
  updateRoles,
  setRoles,
  sentDeleteRoles,
  getRolesBasedOnSearch,
  setSidBasedRoles,
  getSidBasedRoles,
  getAllRolesByAppId,
  setAllRolesSortedByName,
  getErrorMessage
} from '../actions/roles.actions';

export interface RolesState {
  data: any;
  loader: boolean;
  sidRoleData: any;
  searchText: any;
  allRolesSortedByName: any[];
}

export const initialState: RolesState = {
  data: [],
  loader: false,
  sidRoleData: {},
  searchText: '',
  allRolesSortedByName: []
};

export const rolesReducer = createReducer(
  initialState,
  on(getRoles, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants,
    sidRoleData: {},
    searchText: '',
    loader: true
  })),
  on(setRoles, (state, { rolesTable, totalRecords }) => {
    return {
      ...state,
      data: { rolesTable, totalRecords },
      allRolesSortedByName: rolesTable,
      sidRoleData: {},
      loader: false
    };
  }),
  on(sentRoles, (state) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(saveRoles, (state, { saveRolesData }) => {
    const allData = state.data.length > 0 ? [...state.data, saveRolesData] : [saveRolesData];
    return {
      ...state,
      data: allData,
      sidRoleData: {},
      loader: false
    };
  }),
  on(updateRoles, (state, { updateRolesData }) => {
    let allData: any[] = [];
    if (state.allRolesSortedByName.length) {
      const toBeFilteredData = [...state.allRolesSortedByName];
      allData = toBeFilteredData;
      const updateIndex = toBeFilteredData.findIndex((app) => app.sid === updateRolesData.sid);

      if (updateIndex === -1) {
        allData.unshift(updateRolesData);
      } else {
        allData[updateIndex] = updateRolesData;
      }
    } else {
      allData = [updateRolesData];
    }

    let updatedAllRolesSorted = [...state.allRolesSortedByName];
    const sortedUpdateIndex = updatedAllRolesSorted.findIndex((role) => role.sid === updateRolesData.sid); //Find index of the role to update
    if (sortedUpdateIndex === -1) {
      // If role does not exist - add it to the array
      updatedAllRolesSorted.push(updateRolesData);
    } else {
      //If role exists - update it
      updatedAllRolesSorted[sortedUpdateIndex] = updateRolesData;
    }

    // Sort updated roles array alphabetically by 'name'
    updatedAllRolesSorted = updatedAllRolesSorted.sort((a, b) => {
      const nameA = (a.name || '').toLowerCase();
      const nameB = (b.name || '').toLowerCase();
      return nameA.localeCompare(nameB);
    });

    return {
      ...state,
      data: { rolesTable: allData, totalRecords: allData.length },
      allRolesSortedByName: updatedAllRolesSorted,
      sidRoleData: {},
      loader: false
    };
  }),
  on(sentDeleteRoles, (state) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(setRolesToDelete, (state, { rolesWithRefAndDeleted, filterRoles }) => {
    const allRolesData = state.allRolesSortedByName;
    let filteredData;
    if (filterRoles) {
      filteredData = allRolesData.filter((role: { sid: string }) => role.sid !== rolesWithRefAndDeleted);
    } else {
      filteredData = allRolesData;
    }

    return {
      ...state,
      data: { rolesTable: filteredData, totalRecords: filteredData.length },
      allRolesSortedByName: filteredData,
      loader: false
    };
  }),
  on(getSidBasedRoles, (state) => {
    return {
      ...state,
      loader: true,
      sidRoleData: {}
    };
  }),
  on(setSidBasedRoles, (state, { sidRoleData }) => {
    const parsedData = sidRoleData.attachments ? JSON.parse(sidRoleData.attachments) : '';
    const savedDocument = { ...sidRoleData, parsedDocs: [...parsedData] };

    return {
      ...state,
      loader: false,
      sidRoleData: savedDocument
    };
  }),
  on(getRolesBasedOnSearch, (state, { searchFields }) => {
    return {
      ...state,
      searchFields,
      loader: true
    };
  }),
  on(getErrorMessage, (state, errorMessage) => {
    return {
      ...state,
      errorMessage,
      loader: false
    };
  }),
  on(getAllRolesByAppId, (state) => ({
    ...state,
    loader: true
  })),
  on(setAllRolesSortedByName, (state, { sortedRolesByName }) => {
    return {
      ...state,
      sortedRolesByName: sortedRolesByName,
      allRolesSortedByName: sortedRolesByName,
      loader: false
    };
  })
);
